export class FilterRange<T> {
    start: T | undefined;
    end: T | undefined;

    constructor() {
        this.start = undefined;
        this.end = undefined;
    }
}